
    /* eslint-disable */
    /* tslint:disable */
    
    // generated by react-imported-component, DO NOT EDIT     
    import {assignImportedComponents} from 'react-imported-component/macro';
    undefined    
    
    // all your imports are defined here
    // all, even the ones you tried to hide in comments (that's the cost of making a very fast parser)
    // to remove any import from here
    // 1) use magic comment `import(/* client-side */ './myFile')` - and it will disappear
    // 2) use file filter to ignore specific locations (refer to the README - https://github.com/theKashey/react-imported-component/#server-side-auto-import)
    // 3) use .imported.js to control this table generation (refer to the README - https://github.com/theKashey/react-imported-component/#-imported-js)
    
    const applicationImports = assignImportedComponents([
      [() => import('@finect/tabular-text-editor/TextEditor'), '', '@finect/tabular-text-editor/TextEditor', false] /* from ./src/components/Articles/ArticleEditor/ArticleEditor.js */,
      [() => import(/* webpackChunkName: "AboutFinect" */'./scenes/AboutFinect'), 'AboutFinect', './src/scenes/AboutFinect', false] /* from ./src/scenes/index.js */,
      [() => import(/* webpackChunkName: "Guides" */'./scenes/Guides'), 'Guides', './src/scenes/Guides', false] /* from ./src/scenes/index.js */,
      [() => import(/* webpackChunkName: "Legal-EthicalCode" */'./scenes/Legal/EthicalCode'), 'Legal-EthicalCode', './src/scenes/Legal/EthicalCode', false] /* from ./src/scenes/index.js */,
      [() => import(/* webpackChunkName: "Legal-LegalTerms" */'./scenes/Legal/LegalTerms'), 'Legal-LegalTerms', './src/scenes/Legal/LegalTerms', false] /* from ./src/scenes/index.js */,
      [() => import(/* webpackChunkName: "Legal-Terms" */'./scenes/Legal/Terms'), 'Legal-Terms', './src/scenes/Legal/Terms', false] /* from ./src/scenes/index.js */,
      [() => import(/* webpackChunkName: "Pills" */'./scenes/Pills'), 'Pills', './src/scenes/Pills', false] /* from ./src/scenes/index.js */,
      [() => import(/* webpackChunkName: "Recap2024" */'./scenes/Recap/Recap2024'), 'Recap2024', './src/scenes/Recap/Recap2024', false] /* from ./src/scenes/index.js */,
      [() => import(/* webpackChunkName: "Recap2025" */'./scenes/Recap/Recap2025'), 'Recap2025', './src/scenes/Recap/Recap2025', false] /* from ./src/scenes/index.js */,
      [() => import(/* webpackChunkName: "WriteArticle" */'./scenes/Articles/WriteArticle/WriteArticle'), 'WriteArticle', './src/scenes/Articles/WriteArticle/WriteArticle', false] /* from ./src/scenes/index.js */,
    ]);
    
    export default applicationImports;
    
    // @ts-ignore
    if (module.hot) {
       // these imports would make this module a parent for the imported modules.
       // but this is just a helper - so ignore(and accept!) all updates
       
       // @ts-ignore
       module.hot.accept(() => null);
    }    
    